// Access-page API calls (ZS user allowlist). All go through the shared
// apiService (never raw axios/fetch). Trailing slash on the collection route
// matches the backend and avoids a 307 under CORS.

import { apiService } from "src/services";
import { IAccessUser, IUserCreatePayload, IUserUpdatePayload } from "../models/interfaces";
import { IEnvelope, unwrap, apiErrorMessage } from "src/utils/kcc";

// Re-exported so the Access page can import it alongside the API calls.
export { apiErrorMessage };

// GET /users/ — list every ZSer with Control Center access.
export const getUsers = async (): Promise<IAccessUser[]> => {
	const res = await apiService.get<IEnvelope<IAccessUser[]>>("/users/");
	return unwrap<IAccessUser[]>(res) ?? [];
};

// POST /users/ — grant access (@zs.com only, enforced server-side).
export const createUser = async (payload: IUserCreatePayload): Promise<IAccessUser> => {
	const res = await apiService.post<IEnvelope<IAccessUser>, IUserCreatePayload>("/users/", payload);
	return unwrap<IAccessUser>(res);
};

// PATCH /users/{id} — edit name / role / active state.
export const updateUser = async (id: string, payload: IUserUpdatePayload): Promise<IAccessUser> => {
	const res = await apiService.patch<IEnvelope<IAccessUser>, IUserUpdatePayload>(`/users/${id}`, payload);
	return unwrap<IAccessUser>(res);
};

// DELETE /users/{id} — revoke access (removes the allowlist row).
export const deleteUser = async (id: string): Promise<void> => {
	await apiService.delete(`/users/${id}`);
};
